<template>
  <div>
      <v-icon @click="previousDay()">mdi-skip-previous-circle-outline</v-icon>
      <v-icon @click="nextDay()">mdi-skip-next-circle-outline</v-icon>
      Programme du {{ date.format('dddd D MMMM YYYY') }}
      <span style="cursor:pointer;" @click="prepareAll()">♽</span>
      <div class="schedule">
          <div :class="['schedule--hour', {'schedule--preparing': preparing[hour] == true}]" v-for="(items, hour) in schedules" :key="hour">
              <div class="schedule--hour--indicator">{{ hour }}
                  <br>
                  <span @click="prepareHour(hour)">♽</span>
              </div>
              <draggable class="schedule--hour--draggable" v-model="schedules[hour]" group="schedule" :move="move" @change="change($event, hour)">
              <div :class="['schedule--item', 'schedule--item--' + (item.authors && item.authors.length?item.authors[0].slug:item.model.toLowerCase())]" :style="{height: (item.duration+5)/6+'px'}" v-for="(item, index) in items" :key="item.id">
                  <div class="schedule--time">{{ item.start_date.format('HH:mm:ss') }}</div>
                  <div class="schedule--title"><a :href="item.url" target="_blank">{{ item.title }}<template v-if="item.authors && item.authors.length"> <b>({{ item.authors[0].name }})</b></template></a> - {{ item.duration }} ({{ item.start_duration }}/{{ item.overflow_duration }}) &gt; {{ getEndtime(item).format('HH:mm:ss') }}</div>
                <div class="schedule--buttons">
                    <span @click="promptItemAtIndex(hour, index)" class="schedule--add">+</span>
                    <span @click="deleteItem(item)" class="schedule--delete">🗑</span>
                </div>
                <div class="schedule--extra">
                    <img class="schedule--extra--thumbnail" v-if="getThumbnail(item)" :src="getThumbnail(item)">
                </div>
              </div>
              <div v-if="availableTime(hour) > 0" slot="footer" class="schedule--item schedule--item--left" :style="{height: availableTime(hour)/6+'px'}">Reste à combler : {{ availableTime(hour) }} secondes - <span @click="fillHour(hour)">[remplir]</span>
                <div class="schedule--buttons"><span @click="promptItemAtIndex(hour, -1)" class="schedule--add">+</span></div>
              </div>
              </draggable>
          </div>
      </div>
      <div data-app>
          <v-dialog v-model="newScheduleDialog">
              <v-card>
                  <v-card-title class="headline grey lighten-2" primary-title>
                      Article à ajouter ?
                  </v-card-title>

                  <v-card-text>
                      {{ newScheduleHour }}@{{ newScheduleIndex }}
                      <v-text-field label="URL ou id" v-model="scheduleURL"></v-text-field>
                      <v-text-field label="Durée si différente" v-model="scheduleDuration"></v-text-field>
                      <v-text-field label="Timecode de départ si différent" v-model="scheduleStartDuration"></v-text-field>
                      <v-text-field label="Durée de dépassement de créneau horaire" v-model="scheduleOverflowDuration"></v-text-field>
                      <v-checkbox label="Autoriser dépassement" v-model="allowOverFlow"></v-checkbox>
                  </v-card-text>

                  <v-divider></v-divider>

                  <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn color="primary" text @click="newScheduleDialog = false">Annuler</v-btn>
                      <v-btn color="primary" text @click="validateSchedule()">Valider</v-btn>
                  </v-card-actions>
          </v-card>
          </v-dialog>
      </div>
  </div>
</template>

<script>
import moment from 'moment'
import draggable from 'vuedraggable'

moment.locale('fr')

export default {
    name: 'adminschedule',
    components: {
        draggable,
    },
    data() {
        return {
            date: moment(),
            schedules: new Array(24),
            preparing: new Array(24),
            newScheduleDialog: false,
            scheduleURL: '',
            scheduleDuration: '',
            scheduleStartDuration: '',
            scheduleOverflowDuration: '',
            newScheduleHour: 0,
            newScheduleIndex: 0,
            allowOverFlow: false,
        }
    },
    mounted() {
        this.init()
    },
    watch: {
        "$route.params.date"() {
            this.init()
        }
    },
    methods: {
        init() {
            window.vm=this
            window.moment=moment
            this.date = moment(this.$route.params.date)
            this.$store.$api.post('/schedules/check_permission/').then(response => {
                if (response.status == 200) {
                    for(let h = 0 ; h < 24 ; h++) {
                        this.refreshHour(h)
                    }
                } else {
                    alert("Vous n'êtes pas autorisés ici !")
                }
            })
        },
        utcTime(h) {
            return moment.utc(this.date).add(h, 'hours')
        },
        fillHour(h) {
            if (this.preparing[h]) return

            let datetime = this.utcTime(h)
            this.$set(this.preparing, h, true)
            return this.$store.$api.post('/schedules/fill/', {
                date:datetime.format('YYYY-MM-DD'),
                hour:datetime.hour(),
            }).then(() => {
                return  this.refreshHour(h)
            }).then(() => {
                this.$set(this.preparing, h, false)
            })
        },
        refreshHour(h) {
            let datetime = this.utcTime(h)
            this.$store.$api.schedule.search({
                date:datetime.format('YYYY-MM-DD'),
                hour:datetime.hour(),
                limit:999
            }).then(result => {
                this.$set(this.schedules, h, result.articles)
                this.schedules[h].hour = h
            })
        },
        prepareAll() {
            let next = h => {
                this.prepareHour(h).then(() => {
                    if (h <= 22) {
                        next(h+1)
                    }
                })
            }
            next(0)
        },
        prepareHour(h) {
            if (this.preparing[h]) return

            let datetime = this.utcTime(h)
            this.$set(this.preparing, h, true)
            return this.$store.$api.post('/schedules/prepare/', {
                date:datetime.format('YYYY-MM-DD'),
                hour:datetime.hour(),
            }).then(() => {
                return  this.refreshHour(h)
            }).then(() => {
                this.$set(this.preparing, h, false)
            })
        },
        availableTime(hour) {
            let schedule = this.schedules[hour]
            if (schedule && schedule.length) {
                let item = schedule[schedule.length - 1]
                let nextHour = moment(item.start_date).startOf('hour').add(1, 'hour')
                let endTime = this.getEndtime(item, 5)
                return Math.max(0, nextHour.diff(endTime, 'seconds'))
            } else {
                return 3600
            }
        },
        getEndtime(item, padding) {
            padding = padding || 0
            return moment(item.start_date).add(item.duration + padding, 'seconds')
        },
        getThumbnail(item) {
            if (item.thumbs && item.thumbs.length > 0) {
                return item.thumbs[0].url
            }
        },
        deleteItem(item) {
            if (confirm("Supprimer ?")) {
                let hour = item.start_date.hour()
                this.$set(this.preparing, hour, true)
                item.deleteSchedule().then(() => {
                    return this.refreshHour(item.start_date.hours())
                }).then(() => {
                    this.$set(this.preparing, hour, false)
                })
            }
        },
        promptItemAtIndex(hour, index) {
            this.scheduleURL = ''
            this.scheduleDuration = ''
            this.scheduleStartDuration = ''
            this.scheduleOverflowDuration = ''
            this.newScheduleHour = hour
            this.newScheduleIndex = index
            this.newScheduleDialog = true
            this.allowOverFlow = false
        },
        validateSchedule() {
            this.newScheduleDialog = false
            this.$set(this.preparing, this.newScheduleHour, true)
            this.addItemAtIndex(
                this.newScheduleHour,
                this.newScheduleIndex,
                this.scheduleURL,
                this.scheduleDuration,
                this.scheduleStartDuration,
                this.scheduleOverflowDuration,
                this.allowOverFlow,
            ).then(() => {
                return this.refreshHour(this.newScheduleHour)
            }).then(() => {
                this.$set(this.preparing, this.newScheduleHour, false)
            })
        },
        addItemAtIndex(hour, index, article_id, duration, start_duration_override, overflow_duration, allow_overflow) {
            let datetime = this.utcTime(hour)
            return this.$store.$api.post('/schedules/insert/', {
                article_id,
                date:datetime.format('YYYY-MM-DD'),
                hour:datetime.hour(),
                index,
                duration,
                start_duration_override,
                overflow_duration,
                allow_overflow
            }).then(result => {
                let status = result.data.status
                if (status == 'ok') {
                    let slices_to_refresh = result.data.number_of_slices || 1
                    for(let h = hour ; h < hour + slices_to_refresh ; h++) {
                        this.refreshHour(h)
                    }
                } else if (status == 'toolong') {
                    alert("Cette vidéo est trop longue pour le temps disponible");
                } else if (status == 'notfound') {
                    alert("Article introuvable")
                } else if (status == 'invalid') {
                    alert("Article non valide")
                } else {
                    alert('Une erreur inconnue est survenue : ' + status)
                }
            }).catch(() => {
                alert('Une erreur serveur est survenue')
            })
        },
        move(event) {
            let from={
                hour: event.draggedContext.element.start_date.hour(),
                index: event.draggedContext.index,
            }
            let to = {
                hour: event.relatedContext.list.hour,
                index: event.draggedContext.futureIndex,
            }
            if (from.hour != to.hour) {
                // Test if new time slot has enough remaining time available
                console.log(this.availableTime(to.hour), event.draggedContext.element.duration + 5)
                if (this.availableTime(to.hour) < (event.draggedContext.element.duration + 5)) {
                    return false
                }
            }
            if (this.preparing[from.hour] || this.preparing[to.hour]) {
                return false
            }
        },
        change(event, hour) {
            if (event.added) {
                this.$set(this.preparing, hour, true)
                this.addItemAtIndex(
                    hour,
                    event.added.newIndex,
                    event.added.element.url,
                    0
                ).then(() => {
                    return this.refreshHour(hour)
                }).then(() => {
                    this.$set(this.preparing, hour, false)
                })
            }
            if (event.removed) {
                let item = event.removed.element
                this.$set(this.preparing, hour, true)
                item.deleteSchedule().then(() => {
                    return this.refreshHour(hour)
                }).then(() => {
                    this.$set(this.preparing, hour, false)
                })
            }
            if (event.moved) {
                let item = event.moved.element
                this.$set(this.preparing, hour, true)
                item.deleteSchedule().then(() => {
                    this.addItemAtIndex(hour, event.moved.newIndex, item.url, 0).then(() => {
                        return this.refreshHour(hour)
                    }).then(() => {
                        this.$set(this.preparing, hour, false)
                    })
                })
            }
            console.log('change', event, hour)
        },
        switchDay(date) {
            this.$router.push({name: 'admin:schedule', params: {date:date.format('YYYY-MM-DD')}})
        },
        previousDay() {
            this.switchDay(this.date.add(-1, 'days'))
        },
        nextDay() {
            this.switchDay(this.date.add(1, 'days'))
        },
    }
}
</script>

<style lang="scss" scoped>
.schedule {
    position: relative;
    height: 14500px;
    width: 100%;
    font-size: 12px;
}
.schedule--hour--draggable,
.schedule--hour {
    height: 600px;
    position: relative;
    /* overflow: hidden; */
}
.schedule--preparing {
    opacity: 0.5;
}
.schedule--hour--indicator {
    z-index: 2;
    position: absolute;
    left: 0px;
    box-sizing: border-box;
    background-color:orange;
    width: 30px;
    text-align: center;
    padding: 3px 0;
    &::after{
        position: absolute;
        top: 0;
        left: 0;
        width: 95vw;
        border-top: dotted 1px grey;
        content: " ";
    }
    span {
        cursor: pointer;
    }
}
.schedule--item {
    position: relative;
    display: flex; /* contexte sur le parent */
    flex-direction: row; /* direction d'affichage verticale */
    justify-content: center;
    text-align: center;
    left: 30px;
    width:80%;
    box-sizing: border-box;
    border: solid 1px black;
    align-items: center;
    justify-content: flex-start;
}
.schedule--title {
    flex-grow: 1;
    a {
        color: inherit;
    }
}
.schedule--time {
    width: 50px;
    flex-grow: 0;
    background-color: #DFD;
    align-self: flex-start;
    height: 100%;
    color: black;
}
.schedule--item--readingplan { background-color: cyan; }
.schedule--item--readingplan { background-color: #AFA; }
.schedule--item--miracle { background-color: #FAA; }
.schedule--item--logoscom { background-color: #ACC; }
.schedule--item--portes-ouvertes { background-color: #292261; color: white; }
.schedule--item--booste-ta-journee { background-color: yellow; }
.schedule--item--left {
    border: none;
    background: rgba(0,0,0,0.3);
    position: absolute;
    bottom: 0;
}

.schedule--buttons {
    display: none;
    .schedule--item:hover & {
        display: block;
        .schedule--preparing & {
            display: none;
        }
    }
    span {
        position: absolute;
        color: white;
        padding: 0 0.5em;
        border-radius: 50%;
        z-index: 2;
        font-size: 16px;
        border: solid 1px black;
        cursor: pointer;
    }
}
.schedule--extra {
    display: none;
    .schedule--item:hover & {
        display: block;
        position: absolute;
        right: 0;
        top: 0;
        z-index: 1;
        img.schedule--extra--thumbnail {
            max-width: 20vw;
        }
        .schedule--preparing & {
            display: none;
        }
    }
}
.schedule--add {
    background: cyan;
    top: -14px;
    right: -20px;
}
.schedule--delete {
    top: 50%;
    right: 10px;
    background: red;
    transform: translateY(-50%);
    .schedule--item--left & {
        display: none;
    }
}

a {
    text-decoration: none;
}
</style>
